import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { IApplicationInfo } from 'app/models/app-info/app-info';
import { AppService } from 'app/services/app-info/app-info.service';
import { SharedService } from 'app/services/core/shared.service';

@Component({
  selector: 'app-app-info',
  templateUrl: './app-info.component.html'
})
export class AppInfoComponent implements OnInit {

  appInfo: IApplicationInfo = {
    name: '',
    version: '',
    environment: '',
    build: '',
    release: ''
  };
  public environment = environment;

  constructor(public sharedService: SharedService, private readonly service: AppService) { }

  ngOnInit(): void {
    this.service.getAppInfo().subscribe(
      (response) => this.appInfo = response,
      (error) => console.log('error', error)
    );
  }

}
